import { Button, Center, Text, ThemeIcon } from "@mantine/core";
import { Logo } from "../../../layouts/Logo";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../stores/LanguageStore";
import { useSessionStore } from "../../../stores/UserStore";
import { IconCheck } from "@tabler/icons-react";

const AccountVerifiedPage = () => {
  const lang = useLanguage((s) => s.language);
  const setSession = useSessionStore((store) => store.setSession);
  const navigate = useNavigate();

  const handleLogin = () => {
    const params = new URLSearchParams(location.search);
    const refresh = params.get("refresh_token");
    const access = params.get("access_token");

    if (refresh && access) {
      setSession({ access_token: access, refresh_token: refresh });
      setTimeout(() => {
        navigate("/");
      }, 50);
    } else {
      navigate("/login");
    }
  };

  return (
    <Center
      w={"60vw"}
      h={"55vh"}
      style={{ flexDirection: "column" }}
      mx={"auto"}
      mt={128}
    >
      <Logo w={200} mb={64} />
      <ThemeIcon size={96} color="green" radius={"xl"} variant="light" mb={16}>
        <IconCheck size={64} />
      </ThemeIcon>
      <Text fz={28} ta={"center"}>
        {lang.email_validation.success_title} <br />{" "}
        <span style={{ fontSize: 22 }}>
          {lang.email_validation.success_text}
        </span>
      </Text>

      <Button size="md" h={52} mt={"md"} onClick={handleLogin}>
        {lang.password_recovery.step_finish.button_label}
      </Button>
    </Center>
  );
};

export default AccountVerifiedPage;
